import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import FullPageSpinner from 'apex-web/lib/components/common/FullPageSpinner/FullPageSpinner';
import path from '../helpers/path';

const RedirectWithLoaderPage = ({
  pendingAuth,
  isAuthenticated,
  isAuthenticating
}) => {
  if (pendingAuth || (!isAuthenticated && isAuthenticating)) {
    return (
      <div>
        <FullPageSpinner pastDelay isVisible />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Redirect to={path('/login')} />;
  } else {
    return <Redirect to={path('/dashboard')} />;
  }
};

const mapStateToProps = state => ({
  isAuthenticating: !!localStorage.getItem('token'),
  isAuthenticated: state.auth.isAuthenticated,
  pendingAuth: state.auth.pending
});

export default connect(mapStateToProps)(RedirectWithLoaderPage);
